'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_1e09d314 = {"container":"Tag_module_container__22c4800d","active":"Tag_module_active__22c4800d","size-36":"Tag_module_size36__22c4800d","size-44":"Tag_module_size44__22c4800d"};
require("../../../assets/cjs/components/Tag/src/Tag~CyRVHB-8.css");

exports.default = modules_1e09d314;
//# sourceMappingURL=Tag.module.less.js.map
